import React from 'react';
import {
  type Id,
  type ToastContainerProps,
  type ToastOptions,
  Slide,
  toast,
  ToastContainer,
} from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import './black-toast.scss';

type ToastType = 'success' | 'error' | 'warning' | 'info' | 'default';

type TriggerOptions = {
  content: string | React.ReactElement;
  type?: ToastType;
  options?: ToastOptions;
};

export const BlackToastTrigger = ({
  content,
  type = 'default',
  options,
}: TriggerOptions): Id => {
  const toastContent = (
    <div className="tw-w-full tw-text-center">{content}</div>
  );
  const toastOptions = {
    ...options,
    containerId: 'blackToast',
  };

  switch (type) {
    case 'success':
      return toast.success(toastContent, toastOptions);
    case 'error':
      return toast.error(toastContent, toastOptions);
    case 'warning':
      return toast.warning(toastContent, toastOptions);
    case 'info':
      return toast.info(toastContent, toastOptions);
    default:
      return toast(toastContent, toastOptions);
  }
};

export const BlackToastContainer: React.FC<ToastContainerProps> = (props) => (
  <ToastContainer
    position="top-center"
    className="bbk-black-toast-container"
    transition={Slide}
    autoClose={3000}
    icon={false}
    hideProgressBar={false}
    newestOnTop
    closeOnClick
    rtl={false}
    pauseOnFocusLoss={false}
    draggable
    pauseOnHover
    containerId="blackToast"
    closeButton={false}
    {...props}
  />
);
